module.exports = __webpack_public_path__ + "media/customizations/crystallake/back-a7e0ac0763b6b45570ae7ec3152d8e56.jpg";